<template>
  <div class="trial-badge">
    <span v-if="days === null">No free trial</span>
    <span v-else>
      <strong>{{ days }}-day free trial</strong> included
    </span>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  days: number | null
}>()
</script>

<style scoped lang="scss">
.trial-badge {
  display: flex;
  padding: 6px 12px 4px 12px;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  font-size: 12px;
  line-height: 16px;
  margin-top: 8px;
}
</style>
